// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"c18e425b","204":"43a4ab56","468":"143fe681","675":"0db83e38"}[chunkId] + ".chunk.js";
};